import { isNumber } from 'lodash';
import { Vector3 } from 'three';
import { convertLocation, getAvgPoint, setCarHeightPannel } from '@blade-sxp/map/utils';
import { ELementType } from '@blade-sxp/map/src/element';
import { RoiType, HeatMapType } from '@blade-sxp/map/utils/styleType';
import store from '../src/store';
var WEIGHT;
(function (WEIGHT) {
    WEIGHT[WEIGHT["BACKGROUND"] = 0] = "BACKGROUND";
    WEIGHT[WEIGHT["HEATMAPCOMPLEX"] = 1] = "HEATMAPCOMPLEX";
    WEIGHT[WEIGHT["ROI"] = 2] = "ROI";
    WEIGHT[WEIGHT["HEATMAP"] = 3] = "HEATMAP";
    WEIGHT[WEIGHT["Person"] = 4] = "Person";
    WEIGHT[WEIGHT["CAR"] = 5] = "CAR";
    WEIGHT[WEIGHT["PARKING"] = 6] = "PARKING";
    WEIGHT[WEIGHT["Line"] = 7] = "Line";
    WEIGHT[WEIGHT["IMAGE"] = 8] = "IMAGE";
    WEIGHT[WEIGHT["DEVICE"] = 9] = "DEVICE";
    WEIGHT[WEIGHT["TOOLTIPS"] = 10] = "TOOLTIPS";
})(WEIGHT || (WEIGHT = {}));
var ZINDEX;
(function (ZINDEX) {
    ZINDEX[ZINDEX["BACKGROUND"] = 0] = "BACKGROUND";
    ZINDEX[ZINDEX["HEATMAPCOMPLEX"] = 1] = "HEATMAPCOMPLEX";
    ZINDEX[ZINDEX["ROI"] = 2] = "ROI";
    ZINDEX[ZINDEX["HEATMAP"] = 3] = "HEATMAP";
    ZINDEX[ZINDEX["Person"] = 4] = "Person";
    ZINDEX[ZINDEX["PARKING"] = 5] = "PARKING";
    ZINDEX[ZINDEX["CAR"] = 6] = "CAR";
    ZINDEX[ZINDEX["Line"] = 7] = "Line";
    ZINDEX[ZINDEX["IMAGE"] = 8] = "IMAGE";
    ZINDEX[ZINDEX["DEVICE"] = 9] = "DEVICE";
    ZINDEX[ZINDEX["TOOLTIPS"] = 10] = "TOOLTIPS";
})(ZINDEX || (ZINDEX = {}));
/**
 * 处理背景图片格式化数据
 * @param backgroundInfo
 */
export function formatBackground(backgroundInfo, onStart, onProgress, onEnd, onError, roiList, videoList, mode, mainAngle, onComplete) {
    if (backgroundInfo.is3D) {
        return {
            type: ELementType.GLTF,
            id: backgroundInfo.id,
            visible: true,
            zIndex: ZINDEX.BACKGROUND,
            weight: WEIGHT.BACKGROUND,
            position: new Vector3(0, 0, 0),
            renderProps: {
                ...backgroundInfo,
                roiList: roiList,
                videoList: videoList,
                mode: mode,
                onStart: onStart,
                onProgress: onProgress,
                onEnd: onEnd,
                onComplete: onComplete,
                onError: onError,
                mainAngle: mainAngle,
            },
        };
    }
    return {
        type: ELementType.Background,
        id: backgroundInfo.id,
        visible: true,
        width: backgroundInfo.width,
        height: backgroundInfo.height,
        position: new Vector3(0, 0, 0),
        zIndex: ZINDEX.BACKGROUND,
        weight: WEIGHT.BACKGROUND,
        renderProps: backgroundInfo,
    };
}
/**
 * 处理dom格式化数据
 * @param list
 * @returns
 */
export function formatDomList(list, info) {
    const List = [];
    const { width, height, is3D } = info;
    list.map((item) => {
        const { vertices, visible = true, zIndex = 0, opacity = 1, id, vueConfig, isFront, onClick, onMouseDown, onMouseEnter, onMouseLeave, onDestory, onLoad, onMouseUp, onUpdate, ...ohterPorps } = item;
        const { instance, data, emitMethods } = vueConfig || {};
        if (vertices) {
            let x = 0;
            let y = 0;
            let z = 0;
            if (!is3D) {
                const location = convertLocation(vertices.x, vertices.y, {
                    width,
                    height,
                });
                x = location.x;
                y = location.y;
                z = Number(ZINDEX.TOOLTIPS) + Number(zIndex);
            }
            else {
                x = vertices.x;
                y = vertices.y;
                z = vertices.z || 0;
            }
            List.push({
                type: is3D ? ELementType.Dom3d : vueConfig ? ELementType.DomNew : ELementType.DOM,
                id,
                visible: !!visible,
                opacity,
                position: new Vector3(x, y, z),
                zIndex: Number(ZINDEX.TOOLTIPS) + Number(zIndex),
                weight: WEIGHT.TOOLTIPS,
                onClick,
                onMouseDown,
                onMouseEnter,
                onMouseLeave,
                onDestory,
                onLoad,
                onMouseUp,
                onUpdate,
                renderProps: {
                    instance,
                    isFront: isFront,
                    data,
                    emitMethods,
                    ...ohterPorps,
                },
            });
        }
    });
    return List;
}
/**
 * 处理Image格式化数据
 * @param list
 * @returns
 */
export function formatImageList(list, info) {
    const List = [];
    const { width, height, is3D } = info;
    list.map((item) => {
        const { vertices, visible = true, opacity = 1, url, width: imgWidth, height: imgHeight, id, onClick, onMouseDown, onMouseEnter, onMouseLeave, onDestory, onLoad, onMouseUp, onUpdate, ...ohterPorps } = item;
        if (vertices) {
            let x = 0;
            let y = 0;
            let z = 0;
            if (!is3D) {
                const location = convertLocation(vertices.x, vertices.y, {
                    width,
                    height,
                });
                x = location.x;
                y = location.y;
                z = ZINDEX.IMAGE;
            }
            else {
                x = vertices.x;
                y = vertices.y;
                z = vertices.z || 0;
            }
            List.push({
                type: ELementType.IMAGE,
                id,
                visible: !!visible,
                opacity,
                position: new Vector3(x, y, z),
                zIndex: ZINDEX.IMAGE,
                weight: WEIGHT.IMAGE,
                onClick,
                onMouseDown,
                onMouseEnter,
                onMouseLeave,
                onDestory,
                onLoad,
                onMouseUp,
                onUpdate,
                renderProps: {
                    url,
                    width: imgWidth,
                    height: imgHeight,
                    ...ohterPorps,
                },
            });
        }
    });
    return List;
}
/**
 * 处理Person格式化数据
 * @param list
 * @returns
 */
export function formatPersonList(list, info) {
    const List = [];
    if (!list || list.length === 0)
        return [];
    const { is3D, width, height } = info;
    const { angle } = store.weather || {};
    let personColor = '#000000';
    if (angle && (angle < 10 || angle > 170)) {
        personColor = '#ffffff';
    }
    list.map((item) => {
        const { gender, vertices, visible = true, opacity = 1, signalColor, platformId, id, url, width: imgWidth, height: imgHeight, onClick, onMouseDown, onMouseEnter, onMouseLeave, onDestory, onLoad, onMouseUp, onUpdate, ...ohterPorps } = item;
        if (vertices) {
            let x = 0;
            let y = 0;
            let z = 0;
            if (!is3D) {
                const location = convertLocation(vertices.x, vertices.y, {
                    width,
                    height,
                });
                x = location.x;
                y = location.y;
                z = ZINDEX.IMAGE;
            }
            else {
                x = vertices.x;
                y = vertices.y;
                z = vertices.z || 0;
            }
            List.push({
                type: is3D ? ELementType.Person : ELementType.Person2d,
                id,
                visible: !!visible,
                opacity,
                position: new Vector3(x, y, z),
                zIndex: ZINDEX.Person,
                weight: WEIGHT.Person,
                onClick,
                onMouseDown,
                onMouseEnter,
                onMouseLeave,
                onDestory,
                onLoad,
                onMouseUp,
                onUpdate,
                renderProps: {
                    // url,
                    gender,
                    url,
                    width: imgWidth,
                    height: imgHeight,
                    signalColor,
                    platformId,
                },
            });
        }
    });
    if (is3D) {
        return [
            {
                type: ELementType.Persons,
                id: 'person',
                zIndex: ZINDEX.Person,
                weight: WEIGHT.Person,
                position: new Vector3(0, 0, 0),
                list: List,
                personColor,
            },
        ];
    }
    return List;
}
/**
 * 处理小车&小车微数据
 * @param list
 * @param info
 */
export function formatCarParkingList(list, info) {
    const carList = [];
    const parkingList = [];
    if (!list || list.length === 0)
        return [];
    const { is3D, width, height } = info;
    list.map((item) => {
        const { showCar = false, visible = true, opacity, carUrl: url, carWidth: imgWidth, carHeight: imgHeight, id, direction, rotate, theme = 'lotParking', boldVertices, onClick, onMouseDown, onMouseEnter, onMouseLeave, onDestory, onLoad, onMouseUp, onUpdate, ...ohterPorps } = item;
        let { vertices } = item;
        if (vertices?.length) {
            let points;
            if (is3D) {
                vertices = setCarHeightPannel(vertices);
                points = vertices?.map((item) => {
                    return [item.x, item.y, item.z];
                });
            }
            else {
                points = vertices.map((item) => {
                    const { x, y } = convertLocation(item.x, item.y, { width, height });
                    return [x, y, 0];
                });
            }
            parkingList.push({
                type: is3D ? ELementType.Parking3d : ELementType.Parking,
                id: `parking-${id}`,
                visible: !!visible,
                opacity,
                position: new Vector3(0, 0, ZINDEX.ROI),
                zIndex: ZINDEX.PARKING,
                weight: WEIGHT.PARKING,
                onClick,
                onMouseDown,
                onMouseEnter,
                onMouseLeave,
                onDestory,
                onLoad,
                onMouseUp,
                onUpdate,
                renderProps: {
                    ...(RoiType[theme] || RoiType.roi),
                    points,
                    theme,
                    ...ohterPorps,
                },
            });
            if (showCar) {
                const carVertices = [...vertices];
                let x = 0;
                let y = 0;
                let z = 0;
                carVertices.pop();
                const centerPoint = getAvgPoint(carVertices);
                if (!is3D) {
                    const location = convertLocation(centerPoint.x, centerPoint.y, {
                        width,
                        height,
                    });
                    x = location.x;
                    y = location.y;
                    z = ZINDEX.IMAGE;
                }
                else {
                    x = centerPoint.x;
                    y = centerPoint.y;
                    z = centerPoint.z || 0;
                }
                carList.push({
                    type: is3D ? ELementType.Car3D : ELementType.Car2D,
                    id: `car-${id}`,
                    visible: !!visible,
                    position: new Vector3(x, y, z),
                    zIndex: ZINDEX.CAR,
                    weight: WEIGHT.CAR,
                    onClick,
                    onMouseDown,
                    onMouseEnter,
                    onMouseLeave,
                    onDestory,
                    onLoad,
                    onMouseUp,
                    onUpdate,
                    renderProps: {
                        url,
                        points,
                        vertices: carVertices,
                        width: imgWidth,
                        height: imgHeight,
                        rotate,
                        direction,
                    },
                });
            }
        }
    });
    if (is3D) {
        return [
            ...[
                {
                    type: ELementType.Car3DS,
                    id: 'car',
                    zIndex: ZINDEX.CAR,
                    weight: WEIGHT.CAR,
                    position: new Vector3(0, 0, 0),
                    list: carList,
                },
            ],
            ...parkingList,
        ];
    }
    return [...carList, ...parkingList];
}
/**
 * 处理device格式化数据
 * @param list
 * @returns
 */
export function formatDeviceList(list, info) {
    const List = [];
    const { width, height, is3D } = info;
    list.map((item) => {
        const { vertices, visible = true, opacity = 1, id, dom, vueConfig, onClick, onMouseDown, onMouseEnter, onMouseLeave, onDestory, onLoad, onMouseUp, onUpdate, ...ohterPorps } = item;
        const { instance, data, emitMethods } = vueConfig || {};
        if (vertices) {
            let x = 0;
            let y = 0;
            let z = 0;
            if (!is3D) {
                const location = convertLocation(vertices.x, vertices.y, {
                    width,
                    height,
                });
                x = location.x;
                y = location.y;
                z = ZINDEX.DEVICE;
            }
            else {
                x = vertices.x;
                y = vertices.y;
                z = vertices.z || 0;
            }
            List.push({
                type: is3D ? ELementType.Dom3d : vueConfig ? ELementType.DomNew : ELementType.DOM,
                id: `device${id}`,
                visible: !!visible,
                opacity,
                position: new Vector3(x, y, z),
                zIndex: ZINDEX.DEVICE,
                weight: WEIGHT.DEVICE,
                onClick,
                onMouseDown,
                onMouseEnter,
                onMouseLeave,
                onDestory,
                onLoad,
                onMouseUp,
                onUpdate,
                renderProps: {
                    dom,
                    instance,
                    data,
                    emitMethods,
                    // dom: addLabel(device, { data: () => ({ ...item }) }),
                    ...ohterPorps,
                },
            });
        }
    });
    return List;
}
function getCenter(vertices) {
    const maxY = Math.max(vertices[0].y, vertices[1].y);
    return {
        x: (vertices[0].x + vertices[1].x) / 2,
        y: maxY,
        z: ((vertices[0].z || 0) + (vertices[1].z || 0)) / 2,
        radius: Math.sqrt(Math.pow(vertices[0].x - vertices[1].x, 2) + Math.pow((vertices[0].z || 0) - (vertices[1].z || 0), 2)) / 2,
    };
}
function getCenter2D(vertices) {
    return {
        x: (vertices[0].x + vertices[1].x) / 2,
        y: ((vertices[0].y || 0) + (vertices[1].y || 0)) / 2,
        z: 0,
        radius: Math.sqrt(Math.pow(vertices[0].x - vertices[1].x, 2) + Math.pow((vertices[0].y || 0) - (vertices[1].y || 0), 2)) / 2,
    };
}
/**
 * 处理heatmap格式化数据
 * @param list
 * @returns
 */
export function formatHeatMapList(list, info, mode) {
    const { width, height, is3D } = info;
    const List = [];
    if (!list || list.length === 0)
        return [];
    list.map((item, index) => {
        const { id, position, opacity, theme = 'normal', rotateX, rotateY, rotateZ, onClick, onMouseDown, onMouseEnter, onMouseLeave, onDestory, onLoad, onMouseUp, onUpdate, title = '', visible = true, vertices, colorStops, ...ohterPorps } = item;
        if (vertices && theme !== 'complex') {
            let x = 0;
            let y = 0;
            let z = 0;
            let radius = 40;
            if (Array.isArray(vertices)) {
                if (is3D) {
                    const center = getCenter(vertices);
                    radius = center.radius;
                    x = center.x;
                    y = center.y + 1;
                    z = center.z || 0;
                }
                else {
                    const left = convertLocation(vertices[0].x, vertices[0].y, {
                        width,
                        height,
                    });
                    const right = convertLocation(vertices[1].x, vertices[1].y, {
                        width,
                        height,
                    });
                    const center = getCenter2D([left, right]);
                    x = center.x;
                    y = center.y;
                    z = ZINDEX.HEATMAP;
                    radius = center.radius;
                }
            }
            else {
                if (!is3D) {
                    const location = convertLocation(vertices.x, vertices.y, {
                        width,
                        height,
                    });
                    x = location.x;
                    y = location.y;
                    z = ZINDEX.HEATMAP;
                }
                else {
                    x = vertices.x;
                    y = vertices.y + 1;
                    z = vertices.z || 0;
                }
            }
            List.push({
                type: ELementType.HEATMAP,
                id: id || index,
                visible: !!visible,
                opacity,
                position: new Vector3(x, y, z),
                zIndex: ZINDEX.HEATMAP,
                weight: WEIGHT.HEATMAP,
                onClick,
                onMouseDown,
                onMouseEnter,
                onMouseLeave,
                onDestory,
                onLoad,
                onMouseUp,
                onUpdate,
                renderProps: {
                    radius: radius,
                    size: 200,
                    rotateX: rotateX || (is3D ? 0.5 : 0),
                    type: theme,
                    colorStops: colorStops || HeatMapType[theme],
                },
            });
        }
    });
    return [
        {
            type: ELementType.HEATMAPS,
            id: 'heatMap',
            zIndex: ZINDEX.HEATMAP,
            weight: WEIGHT.HEATMAP,
            position: new Vector3(0, 0, 0),
            renderProps: {
                mode: mode,
            },
            list: List,
        },
    ];
}
/**
 * 处理heatmapcomplex格式化数据
 * @param list
 * @returns
 */
export function formatHeatMapComplexList(list, info) {
    const { width, height, is3D } = info;
    const List = [];
    list.map((item, index) => {
        const { id, position, opacity, theme = 'normal', rotateX, rotateY, rotateZ, onClick, onMouseDown, onMouseEnter, onMouseLeave, onDestory, onLoad, onMouseUp, onUpdate, title = '', visible = true, vertices, colorStops, ...ohterPorps } = item;
        if (vertices && theme === 'complex') {
            if (Array.isArray(vertices)) {
                let points = [];
                let z;
                if (!isNumber(vertices[0].x) || !isNumber(vertices[0].y) || !isNumber(vertices[1].x) || !isNumber(vertices[1].y))
                    return;
                if (is3D) {
                    points = vertices;
                }
                else {
                    const left = convertLocation(vertices[0].x, vertices[0].y, {
                        width,
                        height,
                    });
                    const right = convertLocation(vertices[1].x, vertices[1].y, {
                        width,
                        height,
                    });
                    points = [left, right];
                    z = ZINDEX.HEATMAPCOMPLEX;
                }
                List.push({
                    type: is3D ? ELementType.Ellipse3d : ELementType.Ellipse,
                    id: id || index,
                    visible: !!visible,
                    opacity,
                    position: new Vector3(0, 0, z),
                    zIndex: z,
                    weight: WEIGHT.HEATMAPCOMPLEX,
                    onClick,
                    onMouseDown,
                    onMouseEnter,
                    onMouseLeave,
                    onDestory,
                    onLoad,
                    onMouseUp,
                    onUpdate,
                    renderProps: {
                        points: points,
                        size: 200,
                        rotateX: rotateX || (is3D ? 0.5 : 0),
                        type: theme,
                        colorStops: colorStops || HeatMapType[theme],
                    },
                });
            }
        }
    });
    return List;
}
/**
 * 处理roi格式化数据
 * @param list
 * @returns
 */
export function formatRoiList(list, info) {
    // TODO: ROI待定
    const List = [];
    const { width, height, is3D } = info;
    if (is3D) {
        list.map((item) => {
            const { id, position, title = '', opacity, onClick, onMouseDown, onMouseEnter, onMouseLeave, onDestory, onLoad, onMouseUp, onUpdate, visible = true, theme = 'roi', vertices, boldVertices, ...ohterPorps } = item;
            if (item.type && vertices && vertices.length > 0) {
                const points = vertices.map((item) => {
                    return [item.x, item.y, item.z];
                });
                const boldPoints = boldVertices?.map((item) => {
                    return [item.x, item.y, item.z];
                });
                List.push({
                    type: item.type || ELementType.Roi3d,
                    id: id,
                    visible: !!visible,
                    opacity,
                    position: new Vector3(0, 0, ZINDEX.ROI),
                    zIndex: ZINDEX.ROI,
                    weight: WEIGHT.HEATMAPCOMPLEX,
                    onClick,
                    onMouseDown,
                    onMouseEnter,
                    onMouseLeave,
                    onDestory,
                    onLoad,
                    onMouseUp,
                    onUpdate,
                    renderProps: {
                        ...(RoiType?.[theme] || RoiType.roi),
                        text: title,
                        points,
                        theme,
                        boldPoints,
                        ...ohterPorps,
                    },
                });
            }
        });
        return List;
    }
    list.map((item) => {
        const { id, position, title = '', opacity, onClick, onMouseDown, onMouseEnter, onMouseLeave, onDestory, onLoad, onMouseUp, onUpdate, visible = true, theme = 'roi', vertices, boldVertices, ...ohterPorps } = item;
        if (vertices && vertices.length > 0) {
            const points = vertices.map((item) => {
                const { x, y } = convertLocation(item.x, item.y, { width, height });
                return [x, y, 0];
            });
            const boldPoints = boldVertices?.map((item) => {
                const { x, y } = convertLocation(item.x, item.y, { width, height });
                return [x, y, 0];
            });
            List.push({
                type: ELementType.ROI,
                id: id,
                visible: !!visible,
                opacity,
                position: new Vector3(0, 0, ZINDEX.ROI),
                zIndex: ZINDEX.ROI,
                weight: WEIGHT.ROI,
                onClick,
                onMouseDown,
                onMouseEnter,
                onMouseLeave,
                onDestory,
                onLoad,
                onMouseUp,
                onUpdate,
                renderProps: {
                    ...(RoiType?.[theme] || RoiType.roi),
                    text: title,
                    points,
                    boldPoints,
                    ...ohterPorps,
                },
            });
        }
    });
    return List;
}
export function formatLineList(list, info) {
    const List = [];
    const { width, height, is3D } = info;
    list.map((item) => {
        const { id, position, opacity, onClick, onMouseDown, onMouseEnter, onMouseLeave, onDestory, onLoad, onMouseUp, onUpdate, visible = true, theme = 'roi', vertices, ...ohterPorps } = item;
        if (vertices && vertices.length > 0) {
            const points = is3D
                ? vertices.map((item) => {
                    return [item.x, item.y, item.z];
                })
                : vertices.map((item) => {
                    const { x, y } = convertLocation(item.x, item.y, { width, height });
                    return [x, y, ZINDEX.Line];
                });
            List.push({
                type: is3D ? ELementType.LINE3D : ELementType.LINE2D,
                id: id,
                opacity,
                visible: !!visible,
                position: new Vector3(0, 0, ZINDEX.Line),
                zIndex: ZINDEX.Line,
                weight: WEIGHT.Line,
                onClick,
                onMouseDown,
                onMouseEnter,
                onMouseLeave,
                onDestory,
                onLoad,
                onMouseUp,
                onUpdate,
                renderProps: {
                    points,
                    ...ohterPorps,
                },
            });
        }
    });
    return List;
}
export function formatPathList(list, info) {
    const List = [];
    const { width, height, is3D } = info;
    list.map((item) => {
        const { id, position, opacity, visible = true, theme = 'roi', vertices, onClick, onMouseDown, onMouseEnter, onMouseLeave, onDestory, onLoad, onMouseUp, onUpdate, ...ohterPorps } = item;
        if (vertices && vertices.length > 0) {
            const points = is3D
                ? vertices.map((item) => {
                    return [item.x, item.y, item.z];
                })
                : vertices.map((item) => {
                    const { x, y } = convertLocation(item.x, item.y, { width, height });
                    return [x, y, ZINDEX.Line];
                });
            List.push({
                type: is3D ? ELementType.PATH3D : ELementType.PATH2D,
                id: id,
                opacity,
                visible: !!visible,
                position: new Vector3(0, 0, ZINDEX.Line),
                zIndex: ZINDEX.Line,
                onClick,
                onMouseDown,
                onMouseEnter,
                onMouseLeave,
                onDestory,
                onLoad,
                onMouseUp,
                onUpdate,
                renderProps: {
                    points,
                    ...ohterPorps,
                },
            });
        }
    });
    return List;
}
